export enum InvestigationQuestionSource {
	Manual = 1,
	Sabr = 2,
}
